<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Grid.scss";
</style>
<style lang="scss">
  .a-icon{
    outline: none;
    text-decoration: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .a-icon  i{
    font-size: 18px;
  }

  .vs-dropdown--custom {
    width: 220px;
  }
</style>

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right hover:text-white">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Alias')}}</label>
        <vs-input class="w-full" v-model="filters.description" />
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Status')}}</label>
        <v-select class="align-middle" :options="state_values" v-model="filters.status" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center hidden sm:inline-block sm:w-auto">
        <vs-button @click="doFilter()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row mb-5">
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder != 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.ByPage')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="byPage" v-model="filters.limit" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <a v-if="urlDownload.length > 0" class="btn-primary float-right mt-4" :href="urlDownload" download="Agro.csv"><feather-icon icon="DownloadCloudIcon" /></a>
      </div>
    </div>
    <div class="grid-container">
        <vs-dropdown class="float-right mt-4 mr-5" vs-custom-content vs-trigger-click>
          <a class="a-icon" href.prevent>
            {{$t("Labels.ConfigView")}}
            <vs-icon class="" icon="expand_more"></vs-icon>
          </a>
          <vs-dropdown-menu>
            <vs-checkbox class="my-1" v-model="fields.description">{{$t('Labels.Alias')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.environment_temperature">{{$t('Labels.EnvironmentTemperature')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.environment_humidity">{{$t('Labels.EnvironmentHumidity')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.environment_illumination">{{$t('Labels.EnvironmentIllumination')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.environment_o2">{{$t('Labels.EnvironmentO2')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.soil_temperature">{{$t('Labels.SoilTemperature')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.soil_humidity">{{$t('Labels.SoilHumidity')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.soil_electric_conductivity">{{$t('Labels.SoilElectricConductivity')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.soil_n">{{$t('Labels.SoilN')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.soil_p">{{$t('Labels.SoilP')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.soil_k">{{$t('Labels.SoilK')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.soil_ph">{{$t('Labels.SoilPH')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.battery_status">{{$t('Labels.Battery')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.updated_at">{{$t('Labels.Date')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="fields.status">{{$t('Labels.Status')}}</vs-checkbox>
            <div class="text-center">
              <vs-button v-if="$store.state.AppActiveUser.userRole === 'MA'" @click="saveConfig()" class="bg-primary" type="filled" size="small">{{$t("Labels.Save")}}</vs-button>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>
        <div class="item-grid-view vx-row match-height mt-4 cursor-pointer">
            <div :key="item.objectID" @click="goToDetail(item.agro_id)" class="vx-col lg:w-1/4 sm:w-1/2 w-full" v-for="item in response">
                <vx-card class="grid-view-item mb-base overflow-hidden">
                    <gridPrincipalItem v-if="fields.description"
                      img="agro"
                      :name="item.description"
                      :description="$t('Labels.Alias')"
                    ></gridPrincipalItem>
                    <vs-divider/>
                    <valueItem v-if="fields.environment_temperature"
                      :value="parseFloat(item.environment_temperature).toFixed(2)"
                      :description="$t('Labels.EnvironmentTemperature')"
                      unit="°C"
                      img="pressure"
                    ></valueItem>
                    <valueItem v-if="fields.environment_humidity"
                      :value="parseFloat(item.environment_humidity).toFixed(2)"
                      :description="$t('Labels.EnvironmentHumidity')"
                      unit="%"
                      img="pressure"
                    ></valueItem>
                    <valueItem v-if="fields.environment_illumination"
                      :value="parseFloat(item.environment_illumination).toFixed(2)"
                      :description="$t('Labels.EnvironmentIllumination')"
                      unit="%"
                      img="pressure"
                    ></valueItem>
                    <valueItem v-if="fields.environment_o2"
                      :value="parseFloat(item.environment_o2).toFixed(2)"
                      :description="$t('Labels.EnvironmentO2')"
                      unit="%"
                      img="pressure"
                    ></valueItem>
                    <valueItem v-if="fields.soil_temperature"
                      :value="parseFloat(item.soil_temperature).toFixed(2)"
                      :description="$t('Labels.SoilTemperature')"
                      unit="°C"
                      img="globe"
                    ></valueItem>
                    <valueItem v-if="fields.soil_humidity"
                      :value="parseFloat(item.soil_humidity).toFixed(2)"
                      :description="$t('Labels.SoilHumidity')"
                      unit="%"
                      img="globe"
                    ></valueItem>
                    <valueItem v-if="fields.soil_electric_conductivity"
                      :value="parseFloat(item.soil_electric_conductivity).toFixed(2)"
                      :description="$t('Labels.SoilElectricConductivity')"
                      unit="us/cm"
                      img="globe"
                    ></valueItem>
                    <valueItem v-if="fields.soil_n"
                      :value="parseFloat(item.soil_n).toFixed(2)"
                      :description="$t('Labels.SoilN')"
                      unit="mg/L"
                      img="globe"
                    ></valueItem>
                    <valueItem v-if="fields.soil_p"
                      :value="parseFloat(item.soil_p).toFixed(2)"
                      :description="$t('Labels.SoilP')"
                      unit="mg/L"
                      img="globe"
                    ></valueItem>
                    <valueItem v-if="fields.soil_k"
                      :value="parseFloat(item.soil_k).toFixed(2)"
                      :description="$t('Labels.SoilK')"
                      unit="mg/L"
                      img="globe"
                    ></valueItem>
                    <valueItem v-if="fields.soil_ph"
                      :value="parseFloat(item.soil_ph).toFixed(2)"
                      :description="$t('Labels.SoilPH')"
                      unit="mg/L"
                      img="globe"
                    ></valueItem>
                    <valueItem v-if="fields.battery_status"
                      :value="parseFloat(item.battery_status).toFixed(2)"
                      :description="$t('Labels.Battery')"
                      unit="%"
                      img="battery"
                    ></valueItem>
                    <vs-divider/>
                    <valueItem v-if="fields.updated_at"
                      :value="item.updated_at.split(' ')[0]"
                      :description="item.updated_at.split(' ')[1]"
                      img="fecha"
                    ></valueItem>
                    <alertItem v-if="fields.status" :status="item.status === 1? true: false"></alertItem>
                </vx-card>
            </div>
        </div>
        <vs-pagination :max="5" :total="totalPages" v-if="response" v-model="currentx">
        </vs-pagination>
    </div>
  </div>
</template>
<script>
import { request } from '@/request.js'
import vSelect from 'vue-select'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import alertItem from '@/components/alertItem/alertItem.vue'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconFilter from '@/components/icons/iconFilter'

export default {
  components: {
    'v-select': vSelect,
    gridPrincipalItem,
    valueItem,
    alertItem,
    iconBase,
    iconFilterAsc,
    iconFilterDesc,
    iconFilter
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      state_values: [
        { label: 'Todos', value: '' },
        { label: 'Correcto', value: 0 },
        { label: 'Alerta', value: 1 }
      ],
      filters: {
        limit: 20,
        offset: 0,
        byColumn: 'updated_at',
        byOrder: 'ASC',
        description: '',
        status: ''
      },
      urlDownload: '',
      fields: {
        description: false,
        environment_temperature: false,
        environment_humidity: false,
        environment_illumination: false,
        environment_o2: false,
        battery_status: false,
        soil_temperature: false,
        soil_humidity: false,
        soil_electric_conductivity: false,
        soil_n: false,
        soil_p: false,
        soil_k: false,
        soil_ph: false,
        updated_at: false,
        status: false
      },
      fieldsView: [],
      showFilters: false,
      columnOrders: [
        { label: this.$t('Labels.Alias'), value: 'description' },
        { label: this.$t('Labels.Status'), value: 'status' },
        { label: this.$t('Labels.Date'), value: 'updated_at' }
      ],
      byPage: [
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 75, value: 75 },
        { label: 100, value: 100 }
      ]
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()
      const params = {
        url: 'modelo/agro',
        method: 'GET',
        params: this.filters
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        if (this.response.length > 0) {
          this.fieldsView = this.response[0].see_data.split(',')
          this.fieldsView.forEach(element => {
            this.fields[element] = true
          })
        }
        this.setPages(response.data.data.count)
        this.createCsv()
      }).catch(() => {
        this.response = []
        this.setPages(0)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },

    goToDetail (uuid) {
      window.location.href = `/agro/detail/${uuid}`
    },

    createCsv () {
      const csv = []
      const headers = []
      headers.push(this.$t('Labels.Date'))
      headers.push(this.$t('Labels.Alias'))
      headers.push(this.$t('Labels.EnvironmentTemperature'))
      headers.push(this.$t('Labels.EnvironmentHumidity'))
      headers.push(this.$t('Labels.EnvironmentIllumination'))
      headers.push(this.$t('Labels.EnvironmentO2'))
      headers.push(this.$t('Labels.SoilTemperature'))
      headers.push(this.$t('Labels.SoilHumidity'))
      headers.push(this.$t('Labels.SoilElectricConductivity'))
      headers.push(this.$t('Labels.SoilN'))
      headers.push(this.$t('Labels.SoilP'))
      headers.push(this.$t('Labels.SoilK'))
      headers.push(this.$t('Labels.SoilPH'))
      headers.push(this.$t('Labels.Battery'))
      headers.push(this.$t('Labels.Status'))
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.updated_at)
        row.push(item.description)
        row.push(`${item.environment_temperature}`)
        row.push(`${item.environment_humidity}`)
        row.push(`${item.environment_illumination}`)
        row.push(`${item.environment_o2}`)
        row.push(`${item.soil_temperature}`)
        row.push(`${item.soil_humidity}`)
        row.push(`${item.soil_electric_conductivity}`)
        row.push(`${item.soil_n}`)
        row.push(`${item.soil_p}`)
        row.push(`${item.soil_k}`)
        row.push(`${item.soil_ph}`)
        row.push(`${item.battery_status}`)
        row.push((item.status === 1 ? 'Alerta' : 'Correcto'))
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    async saveConfig () {
      let seeData = ''
      for (const p in this.fields) {
        if (this.fields[p] === true) seeData += `${p},`
      }
      const params = {
        url: 'modelo/agro/change_view',
        method: 'PUT',
        params: {
          see_data: seeData
        }
      }
      await request(params)
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },
    resetFilters () {
      this.filters.status = ''
      this.filters.description = ''
    },
    doFilter () {
      if (this.currentx !== 1) { this.currentx = 1 } else { this.getResponse() }
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    }

  },
  sockets: {
    agro (payload) {
      this.response.forEach(toModify => {
        if (toModify.agro_id === payload.uuid) {
          toModify.environment_temperature = payload.environment_temperature
          toModify.environment_humidity = payload.environment_humidity
          toModify.environment_illumination = payload.environment_illumination
          toModify.environment_o2 = payload.environment_o2
          toModify.status = payload.status
          toModify.battery_status = payload.battery_status
          toModify.soil_temperature = payload.soil_temperature
          toModify.soil_humidity = payload.soil_humidity
          toModify.soil_electric_conductivity = payload.soil_electric_conductivity
          toModify.soil_n = payload.soil_n
          toModify.soil_p = payload.soil_p
          toModify.soil_k = payload.soil_k
          toModify.soil_ph = payload.soil_ph
          toModify.updated_at = payload.updated_at
        }
      })
    }
  },
  created () {
    this.getResponse()
  },

  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>
